<template>
    <label :id="id ? `btn-${id}` : null" :class="{ on: modelValue, off: !modelValue }" class="switch form-check-label switch-sm switch-pill shrink-0">
        <input
            :id="id ? `input-${id}` : null"
            :checked="modelValue"
            :disabled="disabled"
            class="switch-input form-check-input"
            name="operability"
            type="checkbox"
            @change="$emit('update:modelValue', $event.target.checked)"
        />
        <span class="switch-slider" />
    </label>
</template>
<script setup>
defineProps(['color', 'disabled', 'modelValue', 'id']);
</script>
